import { call, put, select, takeLatest } from 'redux-saga/effects';

import { FETCH_VISITS_RECORDS, CLEAN_VISITS_RECORDS } from './actionTypes';
import { setVisitsGridIsLoading, setVisitsGridIsNotLoading, setVisitsReports } from './actions';
import { selectVisitsFilters } from './selectors';
import { getVisitReports } from './services';

function* callFetchVisitsRecords() {
  yield put(setVisitsGridIsLoading());
  const visitsFilters = yield select(selectVisitsFilters);
  const response = yield call(getVisitReports, {
    ...visitsFilters,
    page: visitsFilters.pageNumber,
  });

  yield put(setVisitsReports(response));
  yield put(setVisitsGridIsNotLoading());
}

function* callCleanVisitsRecords() {
  yield put(setVisitsGridIsLoading());

  yield put(setVisitsReports({ list: [], totalRecords: 0 }));
  yield put(setVisitsGridIsNotLoading());
}

function* visitsWatcher() {
  yield takeLatest(FETCH_VISITS_RECORDS, callFetchVisitsRecords);
  yield takeLatest(CLEAN_VISITS_RECORDS, callCleanVisitsRecords);
}

export { visitsWatcher };
